/* eslint-disable jira/naming/disallow-filenames */
// eslint-disable-next-line jira/filename-case
import React, { forwardRef, type Ref } from 'react';
import ShowMoreHorizontalIcon from '@atlaskit/icon/core/show-more-horizontal';
import { useIntl, defineMessage } from '@atlassian/jira-intl';
import { CommonNavMenuButton } from '../../../common/ui/common-nav-menu-button/main.tsx';
import type { MoreNavMenuButtonTriggerProps } from './types.tsx';

const moreActions = defineMessage({
	id: 'navigation-apps-sidebar-nav4-common.more-nav-menu-button.trigger.more-actions',
	// eslint-disable-next-line @atlassian/tangerine/i18n/messages-are-spelled-correctly
	defaultMessage: 'More actions',
	description:
		'Used as the alt text for an icon button that when used shows a popup menu of more options.',
});

const moreActionsFor = defineMessage({
	id: 'navigation-apps-sidebar-nav4-common.more-nav-menu-button.trigger.more-actions-for',
	// eslint-disable-next-line @atlassian/tangerine/i18n/messages-are-spelled-correctly
	defaultMessage: 'More actions for {name}',
	description:
		'Used as the alt text for an icon button that when used shows a popup menu of more options. The {name} attribute is the name of the entity the popup menu displays more options for. For example, this could be a project name like "Atlas", and the full message would be "More actions for Atlas".',
});

export const MoreNavMenuButtonTrigger: React.ForwardRefExoticComponent<
	Omit<MoreNavMenuButtonTriggerProps, 'ref'> & React.RefAttributes<HTMLButtonElement>
> = forwardRef(
	// @ts-expect-error: to unblock React 18.2.0 -> 18.3.1 version bump
	({ name, ...props }: MoreNavMenuButtonTriggerProps, ref: Ref<HTMLButtonElement>) => {
		const { formatMessage } = useIntl();

		return (
			<CommonNavMenuButton
				{...props}
				icon={(iconProps) => <ShowMoreHorizontalIcon {...iconProps} size="small" />}
				label={name ? formatMessage(moreActionsFor, { name }) : formatMessage(moreActions)}
				ref={ref}
				isTooltipDisabled={false}
				tooltip={{
					content: formatMessage(moreActions),
					hideTooltipOnClick: true,
				}}
				interactionName="nav4-sidebar-more-actions-button"
			/>
		);
	},
);
